(() => {
  document.querySelectorAll('[data-nv-dining-fit]').forEach(root => {
    if (root.dataset.ready) return;
    const form = root.querySelector('form');
    const status = root.querySelector('[data-dining-status]');
    const plan = root.querySelector('[data-dining-plan]');
    const strip = root.querySelector('[data-dining-strip]');
    const items = Array.from(root.querySelectorAll('[data-dining-item]'));
    const clear = () => {
      items.forEach(item => { item.hidden = false; item.querySelector('[data-dining-match]').hidden = true; });
      status.textContent = root.dataset.initial;
      plan.hidden = true;
    };
    form.addEventListener('submit', event => {
      event.preventDefault();
      const v = Object.fromEntries(['width','places','length','height'].map(key => [key, form.elements.namedItem(key).valueAsNumber]));
      if (!Object.values(v).every(Number.isFinite) || v.width <= 0 || v.length <= 0 || v.height <= 0 || v.places < 0 || v.places * 2 >= v.width) {
        clear(); status.textContent = root.dataset.error; return;
      }
      const available = v.width - v.places * 2;
      let count = 0;
      items.forEach(item => {
        const fits = item.dataset.available === 'true' && Number(item.dataset.width) <= available + 1e-9 && Number(item.dataset.height) <= v.height + 1e-9 && (item.dataset.depth === '' || Number(item.dataset.depth) <= v.length + 1e-9);
        item.hidden = !fits; item.querySelector('[data-dining-match]').hidden = !fits;
        if (fits) count++;
      });
      status.textContent = count ? root.dataset.result.replace('{width}', String(Math.round(available * 100) / 100)).replace('{count}', String(count)) : root.dataset.none;
      strip.setAttribute('x', String(1 + 598 * v.places / v.width));
      strip.setAttribute('width', String(598 * available / v.width));
      plan.hidden = false;
    });
    form.addEventListener('reset', clear);
    root.dataset.ready = 'true'; form.hidden = false;
  });
})();
